export default [
	{ label: 'Event', key: 'event' },
	{ label: 'StartDate', key: 'startDate' },
	{ label: 'EndDate', key: 'endDate' },
	{ label: 'DirectorName', key: 'directorName' },
	{ label: 'DepositAmount', key: 'depositAmount' },
	{ label: 'DepositPaidOn', key: 'depositPaidOn' },
	{ label: 'CompetitionID', key: 'competitionID' },
	{ label: 'Division', key: 'division' },
	{ label: 'SpotFee', key: 'spotFee' },
	{ label: 'Name', key: 'name' },
	{ label: 'NumberAdvancers', key: 'numberAdvancers' },
	{ label: 'DepositAmountReceived', key: 'depositAmountReceived' },
	{ label: 'PaymentAmount', key: 'paymentAmount' },
	{ label: 'PaymentDate', key: 'paymentDate' },
	{ label: 'ConfirmationNumber', key: 'confirmationNumber' },
	{ label: 'NumberSpots', key: 'numberSpots' },
	{ label: 'ExpenseAmount', key: 'expenseAmount' }
 ]


// WEBPACK FOOTER //
// ./src/containers/reports/constants/spotsFeesHeaders.js